<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 offset-sm1 sm10>
        <div class="headline text-xs-center">{{$t('login.heading')}}</div>
      </v-flex>
      <v-flex xs12 offset-sm1 sm10 offset-lg3 lg6 class="mt-3">
        <div class="body-1 pb-1">{{$t('login.text')}}</div>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 offset-sm3 sm6 offset-lg4 lg4>
        <LoginPanel id-prefix="" @logged-in="loggedIn"></LoginPanel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoginPanel from './LoginPanel'
import { IS_STUDENT } from '../../store/getter-types'
import { mapGetters } from 'vuex'

export default {
  name: 'LoginPage',
  components: {
    LoginPanel
  },
  computed: {
    ...mapGetters({
      isStudent: IS_STUDENT
    })
  },
  methods: {
    loggedIn () {
      let name = (this.isStudent) ? 'StudentHome' : 'Dashboard'
      this.$router.push({name})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/LoginPage.vue